import { ERROR_MESSAGE } from "@/constants/message";
import { getErrorReasonMessage } from "@/locales/errorMessages";

type BackendMessageObject = {
  reason?: string;
  message?: string;
};

type BackendErrorShape = {
  reason?: string;
  response?: {
    data?: {
      reason?: string;
      error?: string;
    };
  };
  message?: BackendMessageObject | string;
};

export const getDisplayErrorMessage = (
  error: BackendErrorShape,
  fallbackErrorMessage = "An error occurred"
): string => {
  const reason = error?.reason ?? error?.response?.data?.reason;
  if (reason) {
    const reasonMessage = getErrorReasonMessage(reason);
    if (reasonMessage) return reasonMessage;
  }

  if (typeof error?.response?.data?.error === "string") {
    return error.response.data.error;
  }

  const message = error?.message;
  if (message && typeof message === "object") {
    if (message.reason) {
      const reasonMessage = getErrorReasonMessage(message.reason);
      if (reasonMessage) return reasonMessage;
    }
    return message.message ?? fallbackErrorMessage;
  }

  return message ?? fallbackErrorMessage;
};

/* eslint-disable  @typescript-eslint/no-explicit-any */
export const getErrorMessage = (error: any) => {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    const reason: string | undefined = error.response.data?.reason;
    const reasonMessage = reason ? getErrorReasonMessage(reason) : undefined;

    let errorMessage = error.response.data?.error;
    if (error.response.data?.errors) {
      errorMessage =
        typeof error.response.data?.errors === "string"
          ? error.response.data?.errors
          : Object.values(error.response.data?.errors)[0];
    }
    return {
      status: error.response.status,
      message:
        reasonMessage ?? errorMessage ?? ERROR_MESSAGE.SOMETHING_WENT_WRONG,
      reason,
      details: error.response.data?.error?.details ?? null
    };
  } else if (error.request) {
    // The request was made but no response was received
    // console.log('::ERROR REQUEST:', error.request);
    return {
      status: 500,
      message: error?.message
    };
  } else {
    // Something happened in setting up the request that triggered an Error
    // console.log('::ERROR REQUEST:', error?.message);
    return {
      status: error?.code ?? 500,
      message: error?.message
    };
  }
};
